import React from "react"

import Page from "../components/Page"
import Quote from "../components/Site/Quote"
import Paragraph from "../components/Site/Paragraph"
import PricingForm from "../components/PricingForm"

const Pricing = () => {
  const text = "Wszystkie ceny ustalane są indywidualnie, w zależności od ilości dokumentów i czasu poświęconego na przygotowanie rozliczenia."

  return (
    <Page title="cennik">
      <h1 className="site-title">Cennik</h1>
      <div className="pricing-wrapper">
        <div className="pricing-text">
          <Paragraph text={text} />
          <Quote text="Oferta" />
          <ul className="price-list">
            <li>
              Rejestracja działalności gospodarczej w Revenue
              <i className="pricing-value">€200 (+ VAT)</i>
            </li>

            <li>
              Rejestracja w Revenue jako płatnik podatku VAT
              <i className="pricing-value">€150 (+ VAT)</i>
            </li>

            <li>
              Rozliczenie roczne podatku dochodowego, kalkulacje oraz deklaracja Form 11 Sole Trader
              <i className="pricing-value">€400 (+ VAT)</i>
            </li>

            <li>
              Deklaracja świadcząca brak dochodów w prowadzeniu działalności
              <i className="pricing-value">€150 (+ VAT)</i>
            </li>

            <li>
              Rozliczenie roczne podatku dochodowego, kalkulacje oraz deklaracja Form 11 Partnership
              <i className="pricing-value">€800 (+ VAT)</i>
            </li>

            <li>
              Rozliczenie VAT
              <i className="pricing-value">€135 / miesiąc</i>
            </li>

            <li>
              Rejestracja w Revenue jako pracodawca
              <i className="pricing-value">€50 (+ VAT)</i>
            </li>

            <li>
              Payroll
              <i className="pricing-value">€50 (+ VAT) / pracownika</i>
            </li>

            <li>
              Aplikacja o ulgi podatkowe
              <i className="pricing-value">€50 (+ VAT)</i>
            </li>

            <li>
              Aplikacja Tax Clearance
              <i className="pricing-value">€50 (+ VAT)</i>
            </li>

            <li>
              CRO (rejestracja nazwy dla firmy)
              <i className="pricing-value">€50 (+ VAT)</i>
            </li>

            <li>
              Listy / zaświadczenia do urzędów, Social Welfare, Revenue, zmiana adresu w urzędach, rozdzielenie ulg
              podatkowych
              <i className="pricing-value">€30 (+ VAT)</i>
            </li>

            <li>
              Spotkanie / porada dotycząca założenia i prowadzenia działalności gospodarczej
              <i className="pricing-value">€50 (+ VAT)</i>
            </li>

            <li>
              Pakiet dokumentów do aplikacji o mortgage (PnL za 2-3 lata, tax clearance, assessment letter,
              zaświadczenie z księgowości)
              <i className="pricing-value">€150 (+ VAT)</i>
            </li>

            <li>
              Wygenerowanie dokumentów za poprzednie lata: Employment Summary, Self Assessment, Chapter 4, Form 11
              <i className="pricing-value">€30 (+ VAT)</i>
            </li>
            <li>W pozostałych przypadkach prosimy o kontakt</li>
          </ul>
          <Quote text="Zwrot podatku z tytułu zatrudnienia:" />
          <ul className="price-list">
            <li>
              Sprawdzenie czy należy się zwrot podatku
              <i className="pricing-value"><b>bezpłatnie</b></i>
            </li>
            <li>
              Aplikacja o możliwy zwrot podatku
              <i className="pricing-value">10% od odzyskanej dla klienta kwoty</i>
            </li>
          </ul>
        </div>
        <PricingForm />
      </div>
    </Page>
  )
}

export default Pricing
